import React from "react";
import { useParams } from "react-router-dom";
import { MenuItem, Select, Typography } from "@mui/material";
import { ESRFieldProps } from "../../types/data";
import { useRemoteField } from "../../hooks/useRemoteField";

export const ESRSelectField = (props: ESRFieldProps) => {
	const { question_id, field_options, locked, inline, hint_value, staticValue } = props;
	const [value, setValue] = (staticValue != null) ?
		[staticValue, ()=>{}] : useRemoteField(question_id);
	const handleSelectionUpdate = (val) => {
		setValue(val, locked === -1);
	}
	return (
		<Select
			displayEmpty
			aria-labelledby={question_id}
			inputProps={{ id: question_id }}
			variant={inline ? "standard" : "outlined"}
			fullWidth
			disabled={locked > 0 || staticValue != undefined}
			value={value}
			renderValue={(value: string) => {
				if (!value && hint_value.length > 0) {
					return <Typography color="secondary">{hint_value}</Typography>;
				}
				return <Typography>{value}</Typography>;
			}}
			onChange={(e)=>handleSelectionUpdate(e.target.value)}
			placeholder={
				hint_value.length > 0 && hint_value !== value ? hint_value : undefined
			}
			color={hint_value.length > 0 && hint_value !== value ? "info" : "primary"}
		>
			{field_options.map((o) => {
				return (
					<MenuItem key={o} value={o}>
						{o}
					</MenuItem>
				);
			})}
		</Select>
	);
};